
import store from "../store";
import { setAuthToken } from "../redux/actions/userActions";
import { APIConstants, LoginConstants } from "../utilities/Constants";

export async function fetchWithAuth(url, options = {}) {
  const state = store.getState();
  let token = state.user.token;

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(options.headers || {}),
  };

  if (token) headers["Authorization"] = `Bearer ${token}`;

  try {
    const res = await fetch(url, { ...options, headers });

    if (res.status === 401) {
      const refreshedToken = await refreshToken();
      if (refreshedToken) {
        headers["Authorization"] = `Bearer ${refreshedToken}`;
        return fetch(url, { ...options, headers });
      }
    }

    return res;
  } catch (err) {
    console.error("Fetch error:", err);
    throw err;
  }
}

async function refreshToken() {
  const state = store.getState();
  const userData = state.user.user;
  const practiceID = userData?.practiceID;
  if (!userData || !practiceID) return null;

  try {
    const inputJSON = { UserName: userData.Username, PracticeId: practiceID };
    const url = `${APIConstants.SERVICES_URL}${LoginConstants.UpdatedToken}?sInputJSON=${JSON.stringify(inputJSON)}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error("Token refresh failed");

    const data = await res.json();
    const parsed = JSON.parse(data);
    const token = parsed.AuthToken;

    store.dispatch(setAuthToken(token));
    localStorage.setItem("sAuthToken", token);
    return token;
  } catch (err) {
    console.error("Token refresh failed:", err);
    return null;
  }
}

// hooks/useAuthAndInactivity.js
// import { useEffect, useRef, useCallback } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { setAuthToken } from "../../redux/actions/userActions";
// import { fetchWithAuth } from "../../utils/fetchWithAuth";

// const INACTIVITY_TIMEOUT = 20 * 60 * 1000; // 20 min

// export default function useAuthAndInactivity(userData, userPracticeID, userId) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const inactivityIntervalRef = useRef(null);
//   const initializedRef = useRef(false);

//   const logout = useCallback(async () => {
//     if (!userData) return;

//     try {
//       const inputJson = { UserID: userId, PracticeID: userPracticeID };
//       const url = `${process.env.REACT_APP_SERVICES_URL}/Logout?sInputJSON=${JSON.stringify(inputJson)}`;
//       await fetchWithAuth(url, { method: "POST" });

//       localStorage.clear();
//       sessionStorage.clear();
//       dispatch({ type: "SET_USER", payload: null });
//       dispatch({ type: "SET_AUTHTOKEN", payload: null });
//       navigate("/");
//     } catch (err) {
//       console.error("Logout error:", err);
//     }
//   }, [userData, userPracticeID, userId, dispatch, navigate]);

//   useEffect(() => {
//     if (!userData || initializedRef.current) return;
//     initializedRef.current = true;

//     const events = ["mousemove", "keypress", "click"];
//     const resetTimer = () => localStorage.setItem("lastActivity", Date.now().toString());

//     const checkInactivity = () => {
//       const lastActivity = parseInt(localStorage.getItem("lastActivity") || "0", 10);
//       if (Date.now() - lastActivity > INACTIVITY_TIMEOUT) {
//         console.log("Logging out due to inactivity");
//         cleanup();
//         logout();
//       }
//     };

//     const cleanup = () => {
//       events.forEach((ev) => window.removeEventListener(ev, resetTimer));
//       clearInterval(inactivityIntervalRef.current);
//       inactivityIntervalRef.current = null;
//       initializedRef.current = false;
//     };

//     events.forEach((ev) => window.addEventListener(ev, resetTimer));
//     inactivityIntervalRef.current = setInterval(checkInactivity, 1000);
//     resetTimer();

//     return cleanup;
//   }, [userData, logout]);

//   return { logout };
// }

